export const SAVE_OPENID = 'saveOpenId'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js